module.exports = __webpack_public_path__ + "img/Jump Casting130.e12cec8a.jpg";